module.exports = __webpack_public_path__ + "static/media/floorplan.84c41b8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/FacilityManage/floorplan.png
// module id = 155
// module chunks = 0